const Layout = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "shareModule" */ '../layout/Layout');
const ModulePage = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "shareModule" */ '../pages/module-page/ModulePage');

export const routes = [
  {
    path: '/module',
    name: 'moduleName',
    component: Layout,
    children: [
      {
        path: 'module-page',
        name: 'modulePage',
        component: ModulePage,
      },
    ],
  },
];
